import { render, staticRenderFns } from "./section_1.vue?vue&type=template&id=0823de5c&scoped=true&"
import script from "./section_1.vue?vue&type=script&lang=js&"
export * from "./section_1.vue?vue&type=script&lang=js&"
import style0 from "./section_1.vue?vue&type=style&index=0&id=0823de5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823de5c",
  null
  
)

component.options.__file = "section_1.vue"
export default component.exports